<!--suppress XmlInvalidId -->
<ng-container *ngIf="!sentinelProvisioningService.editingFacility.value && !sentinelProvisioningService.editingDoor.value; else editorSelector">
    <ng-container *ngTemplateOutlet="facilityDetails"></ng-container>
</ng-container>

<ng-template #editorSelector>
    <ng-container *ngTemplateOutlet="sentinelProvisioningService.editingFacility.value ? facilityEditor : doorEditor"></ng-container>
</ng-template>


<ng-template #facilityDetails>
    <div class="p-d-flex p-jc-between p-ai-center">
        <label for="facilitySelector">Facility</label>
        <button pButton (click)="sentinelProvisioningService.editNewFacility()" label="Add Facility" [icon]="icons.PLUS" class="p-button-success p-button-sm"></button>
    </div>
    <div class="p-d-flex p-flex-column p-mt-2">
        <ng-container *ngIf="entries$ | async as entries">
            <div *ngIf="entries.length" class="flex-grow">
                <p-dropdown
                        inputId="facilitySelector"
                        styleClass="w-100"
                        [(ngModel)]="selectedFacility"
                        [options]="entries"
                        emptyMessage="No Facilities"
                        [dataKey]="'facility.id'"
                        optionLabel="label">
                </p-dropdown>
            </div>
        </ng-container>
        <div *ngIf="selectedFacility; let entry" class="p-d-flex p-jc-end p-mt-2">
            <button class="p-button-sm" pButton (click)="sentinelProvisioningService.editFacility(entry.facility)" label="Edit Facility" [icon]="icons.PENCIL"></button>
            <button class="p-button-sm p-button-danger p-ml-2" pButton (click)="confirmFacilityDelete($event, entry)" label="Delete Facility" [icon]="icons.TRASH"></button>
        </div>
    </div>
    <p-divider></p-divider>
    <ng-container *ngIf="selectedFacility; let facility">
        <div class="p-d-flex p-jc-between">
            <label>Doors</label>
            <button pButton
                    (click)="sentinelProvisioningService.editDoor()"
                    label="Add Door"
                    [icon]="icons.PLUS"
                    class="p-button-success p-button-sm p-ml-1"></button>
        </div>
        <p-table styleClass="p-datatable-striped"
                 [value]="facility.doors">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td>
                        <div class="p-d-flex p-jc-center">
                            No Doors
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        <div class="p-grid">
                            <div class="p-col-9 p-d-flex p-flex-column">
                                <label>{{ item.accessPointName }}</label>
                                <div *ngIf="provisionCodes[item.id] | async as code; else provisionButton">
                                    <div>
                                        Provision Code valid for 5 minutes
                                    </div>
                                    <div class="code-well well">
                                        <span>{{ code }}</span>
                                        <button *ngIf="supportsClipboard()"
                                                (click)="copyCodeToClipboard(code)"
                                                pButton
                                                title="Copy to Clipboard"
                                                class="p-mx-2 p-button-outlined p-button-sm"
                                                [icon]="icons.COPY"></button>
                                        <button pButton (click)="createCodeDataUrl(code)" title="Show QR Code" [icon]="icons.QRCODE" class="p-button-outlined p-button-sm" ></button>
                                    </div>
                                </div>
                                <ng-template #provisionButton>
                                    <div>
                                        <button pButton (click)="confirmProvision($event, item)" label="Provision"
                                                class="p-button-text p-p-0"></button>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="p-col p-d-flex p-ai-center p-jc-end">
                                <div class="door-buttons">
                                    <button pButton
                                            class="p-button-sm"
                                            (click)="sentinelProvisioningService.editDoor(item)"
                                            label="Edit"
                                            [icon]="icons.PENCIL"></button>
                                    <button pButton
                                            class="p-button-sm p-button-danger"
                                            (click)="confirmDoorDelete($event, item)"
                                            label="Delete"
                                            [icon]="icons.TRASH"></button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</ng-template>

<ng-template #facilityEditor>
    <facility-editor></facility-editor>
</ng-template>

<ng-template #doorEditor>
    <door-editor></door-editor>
</ng-template>

<p-overlayPanel #provisionDoorConfirm appendTo="body" >
    <div class="p-d-inline-flex p-flex-column">
        <div>
            Are you sure you want to re-provision {{pendingProvision?.accessPointName}}?
            <p>
                Any device currently using the old code will be disconnected.
            </p>
        </div>
        <div class="p-d-flex p-jc-end p-ai-center p-mt-2">
            <button autofocus pButton (click)="provisionDoorConfirm.hide()" label="Cancel" class="p-button-secondary p-button-sm"></button>
            <ng-container *ngIf="pendingProvision?.id as doorId">
                <button pButton (click)="provisionDoorConfirm.hide(); reProvision(doorId)" label="Confirm" class="p-button-sm p-ml-2"></button>
            </ng-container>
        </div>
    </div>
</p-overlayPanel>

<p-overlayPanel #deleteFacilityConfirm appendTo="body">
    <div class="p-d-inline-flex p-flex-column">
        <div>
            Are you sure you want to delete {{pendingDeleteFacility?.facility?.facilityName}}?
        </div>
        <div class="p-d-flex p-jc-end p-ai-center p-mt-2">
            <button autofocus pButton (click)="deleteFacilityConfirm.hide()" label="Cancel" class="p-button-secondary p-button-sm"></button>
            <ng-container *ngIf="pendingDeleteFacility as entry">
                <button pButton
                        (click)="deleteFacilityConfirm.hide(); deleteEntry(entry)"
                        label="Confirm"
                        class="p-button-danger p-button-sm p-ml-2"></button>
            </ng-container>
        </div>
    </div>
</p-overlayPanel>


<p-overlayPanel #deleteDoorConfirm appendTo="body">
    <div class="p-d-inline-flex p-flex-column">
        <div>
            Are you sure you want to delete {{pendingDeleteDoor?.accessPointName}}?
        </div>
        <div class="p-d-flex p-jc-end p-ai-center p-mt-2">
            <button autofocus pButton (click)="deleteDoorConfirm.hide()" label="Cancel" class="p-button-secondary p-button-sm"></button>
            <ng-container *ngIf="pendingDeleteDoor?.id as doorId">
                <button pButton
                        (click)="deleteDoorConfirm.hide(); sentinelProvisioningService.deleteEntity(doorId)"
                        label="Confirm"
                        class="p-button-danger p-button-sm p-ml-2"></button>
            </ng-container>
        </div>
    </div>
</p-overlayPanel>

<p-dialog [visible]="qrCodeDataUrl"
          (onHide)="qrCodeDataUrl = undefined"
          [modal]="true"
          (close)="qrCodeDataUrl = undefined"
          [draggable]="false"
          [closable]="false"
          [resizable]="false">
    <div class="p-d-flex p-flex-column p-jc-center">
        <img *ngIf="qrCodeDataUrl" class="qr-code-provision" [src]="$any(qrCodeDataUrl).dataUrl" alt="QR Code">
        <div class="p-fluid">
            <button pButton (click)="qrCodeDataUrl = undefined" label="Close" class="p-button-secondary p-button-sm"></button>
        </div>
    </div>
</p-dialog>
